import { IRestaurantDevices } from 'types';
import { TDevicesTabCountOfItems, TDevicesTabSortBy } from './devicesTabContext';

export enum DevicesTabActionTypes {
	SET_RESTAURANT_DEVICES = 'SET_RESTAURANT_DEVICES',
	CHANGE_DEVICES_TAB_SEARCH_STRING = 'CHANGE_DEVICES_TAB_SEARCH_STRING',
	SET_DEVICES_TAB_SORT_BY = 'SET_DEVICES_TAB_SORT_BY',
	SET_DEVICES_TAB_COUNT_OF_ITEMS = 'SET_DEVICES_TAB_COUNT_OF_ITEMS',
	CHANGE_DEVICES_TAB_CURRENT_PAGE = 'CHANGE_DEVICES_TAB_CURRENT_PAGE',
}

interface ISetRestaurantDevices {
	type: DevicesTabActionTypes.SET_RESTAURANT_DEVICES;
	payload: {
		restaurantDevices: IRestaurantDevices;
	};
}

interface IChangeDevicesTabSearchString {
	type: DevicesTabActionTypes.CHANGE_DEVICES_TAB_SEARCH_STRING;
	payload: {
		searchString: string;
	};
}

interface ISetDevicesTabSortBy {
	type: DevicesTabActionTypes.SET_DEVICES_TAB_SORT_BY;
	payload: {
		sortBy: TDevicesTabSortBy;
	};
}

interface ISetDevicesTabCountOfItems {
	type: DevicesTabActionTypes.SET_DEVICES_TAB_COUNT_OF_ITEMS;
	payload: {
		countOfItems: TDevicesTabCountOfItems;
	};
}

interface IChangeDevicesTabCurrentPage {
	type: DevicesTabActionTypes.CHANGE_DEVICES_TAB_CURRENT_PAGE;
	payload: {
		currentPage: number;
	};
}

export type TDevicesTabAction =
	| ISetRestaurantDevices
	| IChangeDevicesTabSearchString
	| ISetDevicesTabSortBy
	| ISetDevicesTabCountOfItems
	| IChangeDevicesTabCurrentPage;
